import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { AxiosCustomGet } from "../../../components/axios/AxiosCustom";
import Config from "../../../components/axios/Config";
import SwalToast from "../../../components/helpers/SwalToast";
import AppRoutePath from "../../../router/AppRoutePath";
import httpclient from "../../../components/httpclient";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import { Link, useHistory, useLocation, useRouteMatch } from "react-router-dom";
import RegulerInformationArea from "./components/regularInformation";
import { Button } from "react-bootstrap";
import { FaPlus, FaBan, FaTrashAlt } from "react-icons/fa";
import IsEmpty from "../../../components/helpers/IsEmpty";
import styled from "styled-components";
import ErrorDiv from "../../../components/helpers/ErrorDiv";

export default function AddOutletAppraiser(props) {
  const location = useRouteMatch();
  const history = useHistory();
  const id = location.params.id;
  const dataEdit = props.location.dataEdit;
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [productCategoryList, setProductCategoryList] = useState([]);
  const [appraiserItems, setAppraiserItems] = useState([]);
  const [outletItems, setOutletItems] = useState([]);
  const [outletSelected, setOutletSelected] = useState();
  const [errorOutlet, setErrorOutlet] = useState("");
  const [appraiserCategoryList, setAppraiserCategoryList] = useState([{}]);
  const [errorItemCategory, setErrorItemCategory] = useState("");
  const [errorItemAppraiser, setErrorItemAppraiser] = useState("");
  const [productCategoryLengt, setProductCategoryLength] = useState(0);

  useEffect(() => {
    getMaster();
    getOutlet();
    if (id) {
      setOutletSelected({
        label: dataEdit.name,
        value: dataEdit.outlet_appraisers[0].outlet_id,
      });

      setAppraiserCategoryList(
        dataEdit?.outlet_appraisers.map((item) => ({
          product_category_id: item.product_category_id,
          appraiser_id: item.appraiser_id,
          disable: true,
          data: {
            product_category_id: {
              value: item.product_category_id,
              label: item.product_category_name,
            },
            appraiser_id: {
              value: item.appraiser_id,
              label: item.appraiser_name,
            },
          },
        }))
      );
    }
  }, []);

  const getData = () => {
    setLoading(true);

    let url = `${process.env.REACT_APP_BASE_API_URL}outlet-appraiser/${id}`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        let data = response.data.data;
        setLoading(false);
        setOutletSelected({
          label: data.name,
          value: data.outlet_appraisers[0].outlet_id,
        });
        setAppraiserCategoryList(
          data.dataEdit.map((item) => ({
            product_category_id: item.product_category_id,
            appraiser_id: item.appraiser_id,
            disable: true,
            data: {
              product_category_id: {
                value: item.product_category_id,
                label: item.product_category_name,
              },
              appraiser_id: {
                value: item.appraiser_id,
                label: item.appraiser_name,
              },
            },
          }))
        );
      },
      (error) => {
        setLoading(false);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleSubmit = () => {
    if (!location.params.id) {
      if (!validate()) return;

      let data = {
        id: location.params.id,
        outlet_id: outletSelected.value,
        data: appraiserCategoryList,
      };
      console.log(data);
      setSubmitting(true);
      let url = `${process.env.REACT_APP_BASE_API_URL}outlet-appraiser`;
      httpclient
        .POST(url, data)
        .then((response) => {
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
          history.push(AppRoutePath.APPRAISER_LIST_BY_OUTLET);
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data.error);
            SwalToast.fire({
              icon: "error",
              title: error.response.data.error.message,
            });
          } else {
            console.log(error);
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    } else {
      let data = {
        id: location.params.id,
        outlet_id: outletSelected.value,
        data: appraiserCategoryList,
      };
      console.log(data);
      setSubmitting(true);
      let url = `${process.env.REACT_APP_BASE_API_URL}outlet-appraiser`;
      httpclient
        .POST(url, data)
        .then((response) => {
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
          history.push(AppRoutePath.APPRAISER_LIST_BY_OUTLET);
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data.error);
            SwalToast.fire({
              icon: "error",
              title: error.response.data.error.message,
            });
          } else {
            console.log(error);
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  };

  const getMaster = () => {
    setLoading(true);

    let url = `${process.env.REACT_APP_BASE_API_URL}outlet-appraiser/master-data`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setLoading(false);

        setAppraiserItems(
          response.data.data.appraisers.map((item) => ({
            value: item.id,
            label: item.name,
          }))
        );

        setProductCategoryLength(response.data.data.productCategories.length)
        if (id) {
          setProductCategoryList(
            filterByReference(
              response.data.data.productCategories,
              dataEdit?.outlet_appraisers
            )
          );
        } else {
          setProductCategoryList(
            response.data.data.productCategories.map((item) => ({
              value: item.id,
              label: item.name,
            }))
          );
        }
      },
      (error) => {
        setLoading(false);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const filterByReference = (arr1, arr2) => {
    let res = [];
    res = arr1.filter((el) => {
      return !arr2.find((element) => {
        return element.product_category_id === el.id;
      });
    });
    return res.map((item) => ({
      value: item.id,
      label: item.name,
    }));
  };

  const getOutlet = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}outlet-appraiser/available-outlets`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setLoading(false);
        setOutletItems(
          response.data.data.map((item) => ({
            value: item.id,
            label: item.name,
          }))
        );
      },
      (error) => {
        setLoading(false);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const validate = () => {
    setErrorOutlet();
    let validate = true;

    if (IsEmpty(outletSelected)) {
      validate = false;
      setErrorOutlet("Outlet harus dipilih");
    }

    return validate;
  };

  const validateItems = () => {
    setErrorItemAppraiser("");
    setErrorItemCategory("");
    let validate = true;
    let item = appraiserCategoryList[appraiserCategoryList.length - 1];
    if (!item.appraiser_id) {
      validate = false;
      setErrorItemAppraiser("Pilih juru taksir");
    }
    if (!item.product_category_id) {
      validate = false;
      setErrorItemCategory("Pilih kategori");
    }
    return validate;
  };

  const handleAddItems = () => {
    if (!validateItems()) return;
    setAppraiserCategoryList((prev) => [...prev, {}]);
  };

  const handleDelete = (data) => {
    if (appraiserCategoryList.length > 1) {
      const arr = appraiserCategoryList.filter((item) => item != data);
      setAppraiserCategoryList(arr);
      if (data.data) {
        setProductCategoryList((prevState) => [
          ...prevState,
          { ...data.data.product_category_id },
        ]);
      }
    }
  };

  const handleChangeSelect = (name, data, indexState) => {
    setAppraiserCategoryList((prevState) => {
      const newState = prevState.map((obj, index) => {
        if (index === indexState) {
          return {
            ...obj,
            [name]: data.value,
            disable: (name === "product_category_id" || obj.disable) && true,
            data: { ...obj.data, [name]: data },
          };
        }
        return obj;
      });
      return newState;
    });

    if (name === "product_category_id") {
      const arr = productCategoryList.filter(
        (item) => item.value != data.value
      );
      setProductCategoryList(arr);
    }
  };

  const handleSelectOutlet = (data) => {
    setOutletSelected(data);
  };

  return (
    <div>
      <div className="p-3">
        <div className="mb-3">
          <h5 className="font-weight-bold">
            {!location.params.id
              ? "Atur Juru Taksir per Outlet"
              : "Ubah Area Jemput Gadai"}
          </h5>
          <Breadcrumb current="Atur Juru Taksir per Outlet" />
        </div>
        <div className="container-campaign">
          <div className="container-input-1">
            <div className="container-input my-3">
              <div className="row">
                <div className="col-12">
                  <div className="label-campaign mb-2">Cabang/Outlet</div>
                  <Select
                    isDisabled={id}
                    onChange={(data) => handleSelectOutlet(data)}
                    options={outletItems}
                    value={outletSelected}
                  />
                  <p className="text-danger mt-2">{errorOutlet}</p>
                </div>
              </div>
              {appraiserCategoryList.map((item, index) => {
                return (
                  <div className="container-sk d-flex">
                    <div className="col-5 p-0">
                      <label>Kategori Produk</label>
                      <Select
                        isDisabled={item.disable}
                        onChange={(data) =>
                          handleChangeSelect("product_category_id", data, index)
                        }
                        options={productCategoryList}
                        value={item?.data?.product_category_id}
                      />
                      {appraiserCategoryList.length - 1 == index && (
                        <small className="text-danger mt-2">
                          {errorItemCategory}
                        </small>
                      )}
                    </div>
                    <div className="col-6 pr-0">
                      <label>Juru Taksir</label>
                      <Select
                        onChange={(data) =>
                          handleChangeSelect("appraiser_id", data, index)
                        }
                        options={appraiserItems}
                        value={item?.data?.appraiser_id}
                      />

                      {appraiserCategoryList.length - 1 == index && (
                        <small className="text-danger mt-2">
                          {errorItemAppraiser}
                        </small>
                      )}
                    </div>
                    <FaTrashAlt
                      onClick={() => handleDelete(item)}
                      className="col-1 justify-content-end align-self-center mt-3"
                      size={22}
                      color="#F23434"
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                );
              })}
              {appraiserCategoryList.length !== productCategoryLengt && (
                <div className="d-flex">
                  <div
                    onClick={handleAddItems}
                    style={{
                      color: "#2C465C",
                      cursor: "pointer",
                      marginTop: 20,
                      fontSize: 14,
                      fontWeight: "400",
                      width: "auto",
                      marginRight: 20,
                    }}
                  >
                    <FaPlus className="mr-2" />
                    Tambah Kategori Product
                  </div>
                </div>
              )}
            </div>
            <div className="ml-auto d-flex align-items-center justify-content-end">
              <div onClick={() => history.goBack()}>
                <Button
                  className="btn-action"
                  style={{
                    width: 120,
                    height: 36,
                    margin: 5,
                    background: "#fff",
                    border: "0.75px solid #DCDCDC",
                    color: "#2C465C",
                  }}
                >
                  Kembali
                </Button>
              </div>
              <Button
                id={!location.params.id ? "tambah" : "ubah"}
                onClick={(id) => handleSubmit(id.target.id)}
                variant="primary"
                className="btn-action btn-add"
                style={{ width: 120, height: 36, margin: 5 }}
              >
                {!location.params.id ? "Tambah" : "Ubah"}
              </Button>
            </div>
          </div>

          <RegulerInformationArea />
        </div>
      </div>
    </div>
  );
}

const IconDel = styled.div`
  font-size: 22px;
`;
